import { createSlice } from '@reduxjs/toolkit';

const userDetailsSlice = createSlice({
    name: 'userDetails',
    initialState: {
      userDetails: null,
    },
    reducers: {
      setUserDetails: (state, action) => {
        state.userDetails = action.payload;
      },
      clearUserDetails: (state) => {
        state.userDetails = null;
      }
    },
  });
  
  export const { setUserDetails, clearUserDetails } = userDetailsSlice.actions;
  export default userDetailsSlice.reducer;